import React from 'react';
import NguonLuoiChart from './NguonLuoiChart';
import InRowChart from './InRowChart';
import { UPSChart } from './UPSChart';

export const GetChart = ({ finalId, dashboard = [] }) => {
  const getTypeDashboard = () => {
    return {
      isNguonLuoi: finalId.includes('nguon-luoi'),
      isInRow: finalId.includes('inrow'),
      isUPS: finalId.includes('ups'),
    };
  };

  const { isNguonLuoi, isInRow, isUPS } = getTypeDashboard();
  const renderDashboard = () => {
    if (isNguonLuoi) {
      return <NguonLuoiChart dashboard={dashboard} />;
    }

    if (isInRow) {
      return <InRowChart dashboard={dashboard} />;
    }

    if (isUPS) {
      return <UPSChart dashboard={dashboard} />;
    }

    return null;
  };
  return <>{renderDashboard()}</>;
};
